import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import store from './store/Store';
import { Provider } from 'react-redux';
import HomePage from './page/HomePage';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from './store/SettingSlice';
import * as rdd from 'react-device-detect';
import { Box, Stack, Typography } from '@mui/material';
import { hideMenu } from './store/JSTool';


import NewsListPage from './page/NewsListPage';
import NewsDetailPage from './page/NewsDetailPage';
import AboutUsPage from './page/AboutUsPage';
import ContactPage from './page/ContactPage';
import RecruitPage from './page/RecruitPage';
import PolicyPage from './page/PolicyPage';
import PrivacyPage from './page/PrivacyPage';
import LoadingAndHint from './component/LoadingAndHint';

import HomePageMobile from './mobile/HomePageMobile';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<AppWraper pc={<HomePage />} mb={<HomePageMobile />} />} />
        <Route path='*' element={<AppWraper pc={<HomePage />} mb={<HomePageMobile />} />} />
        <Route path='/newsList' element={<AppWraper pc={<NewsListPage />} mb={<NewsListPage />} />} />
        <Route path='/newsDetail' element={<AppWraper pc={<NewsDetailPage />} mb={<NewsDetailPage />} />} />
        <Route path='/about' element={<AppWraper pc={<AboutUsPage />} mb={<AboutUsPage />} />} />
        <Route path='/contact' element={<AppWraper pc={<ContactPage />} mb={<ContactPage />} />} />
        <Route path='/recruit' element={<AppWraper pc={<RecruitPage />} mb={<RecruitPage />} />} />
        <Route path='/policy' element={<AppWraper pc={<PolicyPage />} mb={<PolicyPage />} />} />
        <Route path='/privacy' element={<AppWraper pc={<PrivacyPage />} mb={<PrivacyPage />} />} />
      </Routes>
      <LoadingAndHint />
    </BrowserRouter>
  </Provider>
);

function AppWraper(props) {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(settingActions.setIsMobile(isMobile()));
  }, []);

  function isMobile() {
    return rdd.isMobile || window.innerWidth < 700;
  }

  return (
    <Stack>
      {isMobile() && props.mb}
      {!isMobile() && props.pc}

      {isMobile() &&
        <Stack
          id='_mask_view'
          onClick={() => {
            hideMenu();
          }}
          sx={{
            position: 'absolute',
            zIndex: 99,
            bgcolor: '#00000066',
            width: 1,
            height: '100vh',
            display: 'none',
          }} />
      }
    </Stack>
  )
}